export const MEXICO_COUNTRY_CODE = '+52';
export const USA_COUNTRY_CODE = '+1';
